import DocsCenter from '../components/DocsCenter'
import { openCenterContent, openCenterSectionToPath } from '../config/open-center-content'

const OpenCenter = () => {
  return (
    <DocsCenter
      docsData={openCenterContent}
      sectionToPath={openCenterSectionToPath}
      basePath="/open-center"
    />
  )
}

export default OpenCenter
